// Generated types for Task
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SubTaskType } from '../../shared/enums';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskNodeReadAPI, TaskNodeWriteAPI } from './tasknode';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskNodeReadAPISchemaObject, TaskNodeWriteAPISchemaObject } from './tasknode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface TaskReadAPI extends TaskNodeReadAPI {
  /** Name for this task, used for Thread naming. Defaults to class name. */
  task_name?: string | null;
  /** How this task relates to its parent for message history construction */
  sub_task_type?: SubTaskType;
  started_at?: string | null;
  completed_at?: string | null;
  created_nodes?: NeoNodeReadAPI[] | null;
}

export interface TaskWriteAPI extends TaskNodeWriteAPI {
  /** Name for this task, used for Thread naming. Defaults to class name. */
  task_name?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const TaskReadAPISchemaObject = TaskNodeReadAPISchemaObject.extend({
  task_name: z.string().nullable().optional(),
  sub_task_type: z.nativeEnum(SubTaskType).optional(),
  started_at: z.string().nullable().optional(),
  completed_at: z.string().nullable().optional(),
  created_nodes: z.array(z.lazy(() => NeoNodeReadAPISchema)).nullable().optional(),
}).passthrough();
export const TaskReadAPISchema: z.ZodType<TaskReadAPI> = TaskReadAPISchemaObject;

export const TaskWriteAPISchemaObject = TaskNodeWriteAPISchemaObject.extend({
  task_name: z.string().nullable().optional(),
}).passthrough();
export const TaskWriteAPISchema: z.ZodType<TaskWriteAPI> = TaskWriteAPISchemaObject;
